
import Vue, { computed } from 'vue';
import { mapGetters, mapActions } from 'vuex';
import Card from '@/components/CardContainer/index.vue';
import CardInfo from '@/components/CardDetails/index.vue';
import Button from '@/components/Button/index.vue';
import Tag from '@/components/Tag/index.vue';
import Accordion from '@/components/Accordion/index.vue';
import Modal from '@/components/Modal/index.vue';
import moment from 'moment';
import { getAgent } from '@/services/user/get-agent';
import { getCofre } from '@/services/tickets/get-cofre';
import getTerritoryByCarCodeService from '@/services/territory/get-territory-by-car-code';
import getTerritoryByIdService from '@/services/territory/get-territory-by-id';
import { actAndAppoitmentGetAll, ActAndAppoitmentGetAllParams } from '@/services/act/act-get-all';
import { getBillingAddress } from '@/services/agent/get-billing-addressId';
import { getAppointment } from '@/services/appoinments/get-appointment';
import { getContestationbyID } from '@/services/contestation/get-contestation-by-id';
import { GetReportParms, getReport } from '@/services/territory/get-report';
import apiGixget from '@/services/appoinments/get-gix';
import getPenalty from '@/services/tickets/get-penalty';
import getTickets from '@/services/tickets/get-tickets';
import { createReportTerm, CreateReportTermParams } from '@/services/territory/create-report-term';
import updateTickets from '@/services/tickets/update-status';
import getAct from '@/services/act/get-act';
import { getPixTxId } from '@/services/pix/get-pix-txid';
import { getPix } from '@/services/pix/get-pix';
import { generateLinkGix } from '@/services/gix/get-link-gix';
import constants from '@/config/constants';
import {
  actCreateCurrent,
} from '@/services/act/act-create-current';
import getTerritoryPenaltyStatus from '@/services/territory/get-territory-penalty-status';
import {
  TerritoryPenaltyStatus, TerritoryPenaltyStatusEnum,
} from '@/config/types';
import { getUserGroup } from '@/utils';
import { getLinkTermCommitmentbyCdAgentCarNumber } from '@/services/term-commitment/get-document-by-cd-agent-car-number';
import {
  actPdfCreate,
} from '@/services/act/get-link-document-act';
import {
  insertConstestation,
  InsertRegisterParams,
  UploadConstestationDocument, UploadConstestationDocumentParams,
} from '@/services/contestation/insert-contestation-register';
import { updateStatusTerritoryOfficial } from '@/services/territory/update-status-territory-oficial';
import { AgentParms, createAgent } from '@/services/territory-access/create-agent';
import RepresentativeModal from '@/views/Producer/NewHome/RegisterTerritory/StepFour/RepresentativeModal/index.vue';
import RepresentativeRegisterModal
  from '@/views/Producer/NewHome/RegisterTerritory/StepFour/RepresentativeRegisterModal/index.vue';
import showError from '@/handler/error';
import {
  Wrapper, Main, CardInfoContentRow, ModalUploadDocument,
} from './styles';

export default Vue.extend({
  components: {
    RepresentativeRegisterModal,
    RepresentativeModal,
    ModalUploadDocument,
    Wrapper,
    Card,
    CardInfo,
    Accordion,
    Button,
    Tag,
    Main,
    Modal,
    CardInfoContentRow,
  },
  data() {
    return {
      userLogged: JSON.parse(sessionStorage.getItem('userLogged') as string),
      condition: false,
      lengthTicket: 0,
      dateAdress: {} as any,
      pixElement: false,
      firstVistory: {} as any,
      visibleModal: true,
      penaltyPageButton: false,
      infoContestation: {} as any,
      linkGix: {} as any,
      dataPenalty: {} as any,
      territory: {
        loaded: false,
        territoryEditionModal: false,
        agents: [{
          id: '',
        }],
        city: '',
        state: '',
        force: '',
        name: '',
        car: '',
        id: '',
        documents: [],
      },
      qrCode: '',
      modalGix: false,
      isOpenModalContestation: false,
      isOpenModalRepresentativeConfirmed: false,
      isOpenModalRegisterRepresentative: false,
      isOpenModalContestationUpload: false,
      modalContestationUploadEnableSentBtn: false,
      modalContestationUploadfileNotAccept: false,
      modalContestationOk: false,
      fileUploadName: [],
      month: 0,
      qrCodePix: '',
      dateArray: [{
        date: '',
      }] as any,
      dataFinal: '',
      digitalSafe: '',
      addressObject: {} as any,
      respReturn: {} as any,
      actDataResult: [] as any[],
      actDataResultFilter: [] as any[],
      statusPix: '',
      actData: {} as any,
      territoryPenaltyStatus: {} as TerritoryPenaltyStatus,
      gixData: {} as any,
      statusFlag: {} as TerritoryPenaltyStatus,
      linkActPdf: '',
      userLoged: JSON.parse(sessionStorage.getItem('userLogged') as string),
      territoryArray: [] as any[],
      objAct: {} as any,
      dataCdTerritory: {
        cdTerritory: '',
      } as any,
      tickets: {} as any,
      ticketsTwo: {} as any,
      ticketsResult: {} as any,
      allPayed: false,
      headerColumns: ['Tipo', 'Data de Inicio', 'Fim do prazo', 'Status', 'Resultado', 'PDF'],
      territoryByCar: {
        loaded: false,
        aderiuPRA: '',
        area: '',
        condigo: '',
        dataAnalise: '',
        dataRegistro: '',
        dataRetificacao: '',
        latitude: '',
        longitude: '',
        modulosFiscais: '',
        statusImovel: '',
        condicaoAnalise: '',
        estado: '',
      },
      txId: '',
      loading: false,
      territoryEditionModal: false,
      cardData: [{
        label: '',
        value: '',
      }],
      termSocioEnvironmental: {
        type: 'termSocioEnvironmental',
      } as any,
      term: {
        termId: 0,
        urlFile: '',
      },
      termCommitment: 'nulo',
      termCommitmentTwo: 'nulo',
      statusContastation: '',
      enableContestationBtn: false,
      enablePendingContestationText: false,
      loadingContestationBtn: true,
      cardDataInfo: [
        [
          { label: 'Nome da Fazenda', value: 'Fazenda esperança' },
          { label: 'CNPJ:', value: '89.007.355/0001-16' },
          { label: 'Município / UF:', value: 'Tangará da Serra (MT)' },
          { label: 'Registro no CAR:', value: 'MT-CAR-11111111111111' },
          { label: 'Data de registro no SiCAR:', value: '14/01/2016' },
          { label: 'Data da análise do CAR:', value: '10/06/2020' },
          { label: 'Data da última retificação:', value: '30/06/2020' },
          { label: 'Área do imóvel:', value: '2.435,85 ha' },
          { label: 'Módulos fiscais:', value: '24,04' },
          { label: 'Coordenadas:', value: "Lat 09º40'53.,74'S  /  Long 56º52'39,62'O" },
        ],
        [
          { label: 'Situação cadastro:', value: 'Ativa', tag: true },
          { label: 'Condição cadastro:', value: 'Em análise', tag: true },
          { label: 'Aderiu ao programa de regularização ambiental:', value: 'Sim' },
        ],
      ],
      cardDataProp: [
        [
          { label: 'Nome:', value: 'Luiz Paulo Medeiros' },
          { label: 'CNPJ:', value: '89.007.355/0001-16' },
        ],
        [
          { label: 'Nome:', value: 'Patrícia Monteiro' },
          { label: 'CNPJ:', value: '89.007.355/0001-16' },
        ],
      ],
    };
  },
  computed: {
    constation(): any[] {
      return this.dateArray.map((contest: any) => ({
        date: contest.date,
      }));
    },
    address() {
      if (this.addressObject.objectResult) {
        return { ...this.addressObject.objectResult };
      }
      return {};
    },
    getStepDate() {
      return {
        conditionSkip: false,
        currentStep: 1,
        address: { ...this.address },
        territory: {
          ...this.territory,
          representative: {
            name: '',
            document: '',
            office: '',
          },
        },
        agent: { ...this.territory.agents[0] },
      };
    },
    contestationDocuments() {
      const documents = this.territory?.documents?.filter((document: any) => document?.type?.toUpperCase().includes('CONTDOC'));
      if (!documents) return [];

      return [...documents];
    },
  },
  methods: {
    ...mapActions({ getAppointmentDate: 'getAppointmentDate', getAppointmentData: 'getAppointmentData' }),
    ...mapGetters(['appointments']),
    IsEqualDate(date1: string, date2: string) {
      return moment(date1, 'DD/MM/YYYY').unix() - moment(date2, 'DD/MM/YYYY').unix();
    },
    closeModal() {
      this.modalGix = !this.modalGix;
    },
    onCloseModalContestation() {
      this.isOpenModalContestation = false;
    },
    handleUpload() {
      this.$refs.uploadContestation.click();
    },
    updateSelect() {
      const upload = this.$refs.uploadContestation;
      if (!upload.files) {
        this.fileUploadName = [];
        this.modalContestationUploadEnableSentBtn = false;
        this.modalContestationUploadfileNotAccept = false;
        return;
      }
      const selectedFiles = Array.from(upload.files);
      if (selectedFiles.length === 0) {
        this.fileUploadName = [];
        this.modalContestationUploadEnableSentBtn = false;
        this.modalContestationUploadfileNotAccept = false;
        return;
      }
      const tryUploadName = selectedFiles[0].name;
      if (tryUploadName.split('.').pop().toLowerCase() !== 'pdf') {
        this.modalContestationUploadfileNotAccept = true;
        this.modalContestationUploadEnableSentBtn = false;
        this.fileUploadName = [];
        return;
      }
      this.fileUploadName = [tryUploadName];
      this.modalContestationUploadfileNotAccept = false;
      this.modalContestationUploadEnableSentBtn = true;
    },
    removeContestationDocument(fileName: string) {
      const dataTransfer = new DataTransfer();
      const inputUpload = this.$refs.uploadContestation;
      Array.from(inputUpload.files).forEach((fileInput) => {
        if (fileInput.name !== fileName) {
          dataTransfer.items.add(fileInput);
        }
      });
      inputUpload.files = dataTransfer.files;
      this.updateSelect();
    },
    async getLinkDocumentTermCommitment() {
      this.addressObject = await getBillingAddress(this.userLoged.company.stKey, this.userLoged.idUser);
      const response = await getLinkTermCommitmentbyCdAgentCarNumber(
        this.userLoged.company.stKey,
        (this as any).territory.agents[0].id,
        this.territory.car,
      );
      this.termCommitment = response.objectResult;
      if (this.termCommitment === null || this.termCommitment === 'nulo') {
        await this.createReportTermRequest();
      }
    },
    async createReportTermRequest() {
      const params: any = {
        nameMain: this.userLoged.stName,
        document: this.userLoged.stDocument,
        tokenKey: this.userLoged.company.stKey,
        cdTerritory: this.$route.params.id,
        carNumber: this.territory.car.replaceAll('-', ''),
        territoryName: this.territory.name,
        street: this.addressObject.objectResult.address,
        number: this.addressObject.objectResult.number,
        complement: this.addressObject.objectResult.address,
        city: this.addressObject.objectResult.city,
        state: this.addressObject.objectResult.state,
        cep: this.addressObject.objectResult.zipCode,
        email: this.userLoged.stEmail,
        telephone: this.userLoged.stPhone,
        cdAgent: this.territory.agents[0].id,
        representativeName: '',
        representativeDocumentNumber: '',
        representativePosition: '',
        isAssing: true,
      };
      const loader = this.$loading.show({ container: this.$refs.formContainer, canCancel: false });
      return createReportTerm(params).then((data) => {
        this.termCommitmentTwo = { ...this.dateAdress, ...data };
        loader.hide(); // Mova o loader.hide() para dentro do then
      }).catch((error) => {
        console.error(error);
        loader.hide(); // Certifique-se de que o loader também será escondido em caso de erro
      });
    },
    async getTerritoryById() {
      /* eslint max-len: ["error", { "code": 147 }] */
      const { id } = this.$route.params;

      const response = await getTerritoryByIdService(id);
      if (response.hasErrors) this.$router.push('/not-found');

      this.territory = response.objectResult;

      this.territory.loaded = true;

      if (this.isAdminUser()) {
        this.territoryPenaltyStatus = await this.getTerritoryPenaltyStatus(id);
      }

      let documentCAR;

      if (response.objectResult.documents) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.territory.documents.forEach((document: any, index) => {
          if (document?.type?.toUpperCase().includes('TERCOM')) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (this as any).territory.documents[index].title = document.title !== '' ? document.title : this.$t('terms');
          }
        });
        documentCAR = response.objectResult.documents.find(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (document: any) => document?.type?.toUpperCase().includes('CARDOC'),
        );
      }

      if (documentCAR) {
        this.territory.car = documentCAR.title;
        this.getTerritoryByCarCode(this.territory.car);
      } else {
        this.territoryByCar.loaded = true;
      }
    },
    openPix() {
      this.$router.push({ name: 'PayPixInfo', params: { id: this.$route.params.id } });
    },
    payPix(value) {
      this.territoryEditionModal = true;
      this.visibleModal = true;
      this.qrCode = value;
    },
    close() {
      this.territoryEditionModal = false;
      this.visibleModal = false;
    },
    openModal() {
      this.modalGix = !this.modalGix;
    },
    copyURL() {
      navigator.clipboard
        .writeText(this.linkGix[0].url)
        .then(() => {
          Vue.swal('', 'Link da Sua Jornada no Gix copiado com sucesso!', 'success');
        })
        .catch(() => {
          Vue.swal('', 'Erro ao copiar link', 'error');
        });
    },
    async getReportRequest() {
      const params: GetReportParms = {
        cdUser: this.userLoged.idUser,
        tokenKey: this.userLoged.company.stKey,
        cdTerritory: this.territory.id,
      };
      getReport(params).then((data) => {
        this.termSocioEnvironmental = { ...this.termSocioEnvironmental, ...data };
      });
    },
    async appointmentRequest() {
      const params: ActAndAppoitmentGetAllParams = {
        cdTerritory: this.territory.id,
        tokenKey: this.userLoged.company.stKey,
        agentId: this.territory.agents[0].id,
      };
      this.firstVistory = await getAppointment(params);
      const dtStart = new Date(this.firstVistory[0].dtAppointment);
      this.month = dtStart.getMonth() + 1;
      actAndAppoitmentGetAll(params).then((resp) => {
        this.territoryArray = resp.data;
        this.gixData.then((result) => {
          this.objAct = result.data.objectResult;
          for (let i = 0; i < this.objAct.length; i += 1) {
            if (this.objAct[i].dtJourneyFirstTaskStart !== null && this.objAct[i].cdTerritory.slice(-19) === resp.data[0].cdTerritory.slice(-19)) {
              const dtStart = new Date(this.firstVistory[0].dtAppointment);
              const dt = new Date(this.objAct[i].dtJourneyFirstTaskStart);
              dt.setDate(dt.getDate() + 7);
              const formated = moment(dt).format('YYYY-MM-DD');
              this.dateArray.push({ date: formated });
              this.dataFinal = formated;
              this.month = dtStart.getMonth() + 1;
              if (this.ticketsTwo.objectResult.length === 0) {
                this.limiter(this.dataFinal, this.firstVistory[0].dtAppointment);
              }
              if (this.month === 12 || this.month === 1 || this.month === 2 || this.month === 3) {
                if (resp.hasAct) {
                  /* const data: ActCreateParams = {
                    territoryId: this.territory.id,
                    tokenKey: this.userLoged.company.stKey,
                    dtAutovistory: formated,
                    score: this.objAct[i]?.journeyTaskQuizAnswerGroup[0]?.stScore,
                    period: 'Chuvoso',
                  }; */
                  getPixTxId(this.territory.id, this.userLoged.company.stKey).then((responseTxid) => {
                    this.txId = responseTxid[0].txId;
                    if (responseTxid.length > 0) {
                      getPix(this.txId).then((respData) => {
                        if (respData.status === 'CONCLUIDA') {
                          // actCreatebyPix(data);
                        }
                      });
                    }
                  }).catch(() => {
                    // actCreate(data);
                  });
                }
              } else if (this.month === 6 || this.month === 7 || this.month === 8 || this.month === 9) {
                if (resp.hasAct) {
                  /* const data: ActCreateParams = {
                    territoryId: this.territory.id,
                    tokenKey: this.userLoged.company.stKey,
                    dtAutovistory: formated,
                    score: this.objAct[i]?.journeyTaskQuizAnswerGroup[0]?.stScore,
                    period: 'Seco',
                  }; */
                  getPixTxId(this.territory.id, this.userLoged.company.stKey).then((responseTxid) => {
                    this.txId = responseTxid[0].txId;
                    if (responseTxid.length > 0) {
                      getPix(this.txId).then((respData) => {
                        if (respData.status === 'CONCLUIDA') {
                          // ctCreatebyPix(data);
                        }
                      });
                    }
                  }).catch(() => {
                    // actCreate(data);
                  });
                }
              } else if (this.month === 4 || this.month === 5 || this.month === 10 || this.month === 11) {
                if (resp.hasAct) {
                  /* const data: ActCreateParams = {
                    territoryId: this.territory.id,
                    tokenKey: this.userLoged.company.stKey,
                    dtAutovistory: formated,
                    score: this.objAct[i]?.journeyTaskQuizAnswerGroup[0]?.stScore,
                    period: 'Transição',
                  }; */
                  getPixTxId(this.territory.id, this.userLoged.company.stKey).then((responseTxid) => {
                    this.txId = responseTxid[0].txId;
                    if (responseTxid.length > 0) {
                      getPix(this.txId).then((respData) => {
                        if (respData.status === 'CONCLUIDA') {
                          // actCreatebyPix(data);
                        }
                      });
                    }
                  }).catch(() => {
                    // actCreate(data);
                  });
                }
              }
            }
          }
        });
      });
    },
    goToGeo(dataType: string, dataInitial: string, dataEnd: string) {
      if (dataType === 'Geomonitoramento') {
        this.$router.push({ name: 'Geomonitoramento', params: { dataStart: dataInitial, dataEnd } });
        return;
      }

      if (dataType === 'Autovistoria') {
        this.$router.push({ name: 'Autovistoria', params: { dataStart: dataInitial, dataEnd } });
      }
    },
    async limiter(value, value2) {
      this.ticketsTwo = await getTickets({ cdTerritory: this.territory.id });
      if (this.ticketsTwo.objectResult.length === 0) {
        const dtStart = new Date(value2);
        this.month = dtStart.getMonth() + 1;
        this.actDataResultFilter = this.actDataResult;
        const dt = new Date(value);
        if (this.month === 4 || this.month === 5 || this.month === 10 || this.month === 11) {
          const dataComAcrescimo = moment(dt).add(3, 'months').add(2, 'days');
          const formated = moment(dataComAcrescimo).format('YYYY-MM-DD');
          this.actDataResultFilter = this.actDataResult.filter((evento) => {
            return evento.act < formated;
          });
        } else {
          const dataComAcrescimo = moment(dt).add(6, 'months').add(2, 'days');
          const formated = moment(dataComAcrescimo).format('YYYY-MM-DD');
          this.actDataResultFilter = this.actDataResult.filter((evento) => {
            return evento.act < formated;
          });
          const params = {
            territoryId: this.actDataResultFilter[this.actDataResultFilter.length - 1].cdTerritory,
            tokenKey: this.userLoged.company.stKey,
            dtAutovistory: this.actDataResultFilter[this.actDataResultFilter.length - 1].act,
          };
          await actCreateCurrent(params);
        }
      }
    },
    async getLinkGix() {
      const params: any = {
        cdTerritory: this.territory.id,
        tokenKey: this.$store.state.userLogged.company.stKey,
      };
      this.linkGix = await generateLinkGix(params);
    },
    goToPenaltyPage() {
      const documentData = this.userLoged.stDocument;
      const installments = this.dataPenalty[0].totalInstallments;
      const paymentValue = this.dataPenalty[0].totalAmount;
      const contastation = this.infoContestation[0].status;
      const { id } = this.territory;
      this.$router.push({
        name: 'PaymentPayInfo',
        params: {
          paymentValue, installments, documentData, id, contastation,
        },
      }, () => {
        Vue.$toast.success('Operação realizada com exito!');
      });
    },
    openDocumentPdf(url: string) {
      this.loading = true;
      window.open(url, '_blank');
      this.loading = false;
    },
    async getTerritoryByCarCode(carCode: string) {
      const { objectResult } = await getTerritoryByCarCodeService(carCode);

      if (objectResult) this.territoryByCar = objectResult.dadosExtratoPdf;

      this.territoryByCar.loaded = true;
    },
    async verifyPenalty() {
      const { id } = this.$route.params;
      this.statusFlag = await this.getTerritoryPenaltyStatus(id);
    },
    isAdminUser() {
      return getUserGroup() === constants.roles.admin;
    },
    getTerritoryPenaltyStatus(territoryId: string) {
      return getTerritoryPenaltyStatus(territoryId);
    },
    displayPenaltyPageButton() {
      return this.isAdminUser() && this.territoryPenaltyStatus.id === TerritoryPenaltyStatusEnum.pending;
    },
    convertDataTicketsArray() {
      for (let i = 0; i < this.ticketsTwo.objectResult.length; i += 1) {
        this.ticketsTwo.objectResult[i].dueDate = moment(this.ticketsTwo.objectResult[i].dueDate).format(
          'DD/MM/YYYY',
        );
        if (this.ticketsTwo.objectResult[i].status === 'payed') {
          this.ticketsTwo.objectResult[i].status = 'Pago';
        } else if (this.ticketsTwo.objectResult[i].status === 'pending') {
          this.ticketsTwo.objectResult[i].status = 'Pendente';
        } else if (this.ticketsTwo.objectResult[i].status === 'cancelled') {
          this.ticketsTwo.objectResult[i].status = 'Cancelado';
        }
      }
    },
    async getDocumentContastation() {
      const tokenKey = this.userLoged.company.stKey;
      const document = this.userLoged.stDocument;
      const agentId = await getAgent({ tokenKey, document });
      const agentIdItem = agentId.id;
      const response = await getCofre(tokenKey, agentIdItem);
      response.map((e) => {
        if (e.cdTerritory === this.$route.params.id) {
          e.digitalSafes.map((k) => {
            if (k.vlUrlDownload !== '' && k.nmFileType?.toUpperCase().includes('CONTDOC')) {
              this.digitalSafe = k.vlUrlDownload;
              return k;
            }
            return false;
          });
          return e;
        }
        return false;
      });
    },
    async openContestation(link: string) {
      window.open(link, '_blank');
    },
    async getStatus() {
      this.loadingContestationBtn = true;
      try {
        const stKey = this.userLoged.company.stKey.toString();
        const resp = await getContestationbyID(stKey, this.territory.id);
        this.infoContestation = resp.objectResult || [];
        if (resp.HasErrors) {
          this.enableContestationBtn = false;
          this.loadingContestationBtn = false;
          showError('não foi possível carregar informações referente a contestação');
          return;
        }
        if (!!this.infoContestation && this.infoContestation.length > 0) {
          this.statusContastation = this.infoContestation[0].status;
          const allContestationAreCompleted = this.infoContestation.every((item) => item.status.toLowerCase() !== 'pendente');
          this.enableContestationBtn = allContestationAreCompleted;
          this.enablePendingContestationText = !allContestationAreCompleted;
          this.loadingContestationBtn = false;
          return;
        }
        this.loadingContestationBtn = false;
        this.enableContestationBtn = true;
      } catch (e) {
        this.enableContestationBtn = false;
        this.loadingContestationBtn = false;
        showError('não foi possível carregar informações referente a contestação');
      }
    },
    async actCreatePdf(dataInitial: string, dataEnd: string) {
      const loader = this.$loading.show({
        container: this.$refs.formContainer,
      });
      const params: any = {
        tokenKey: this.userLoged.company.stKey,
        carNumber: this.territory.car,
        cdAgent: this.territory.agents[0].id,
        validityDateACT: moment(dataEnd).format('DD/MM/YYYY'),
        issueDateACT: moment(dataInitial).format('DD/MM/YYYY'),
        // @ts-ignore
        territoryName: this.territory.name,
        city: this.territory.city,
        state: this.territoryByCar.estado,
      };
      const response = await actPdfCreate(params);
      loader.hide();
      window.open(response.objectResult, '_blank');
    },
    redirectToTerritoryDetailsPage(paymentValue, installments, documentData) {
      this.$router.push({ name: 'PaymentPay', params: { paymentValue, installments, documentData } }, () => {
        Vue.$toast.success('Operação realizada com exito!');
      });
    },
    async changeStatusTerritoryCarRequest(status: 'INATIVO' | 'PROVISORIO') {
      const { idUser } = this.userLogged;

      const params: AgentParms = {
        territories: [
          {
            cdTerritory: this.getStepDate.territory.id,
            vlStatus: status,
            dbOperation: 'Update',
          },
        ],
        requestSource: {
          fkSystem: '1',
          fkUser: idUser,
        },
      };

      await createAgent(params);
    },
    onSubmitRepresentive() {
      this.isOpenModalRegisterRepresentative = false;
      this.isOpenModalRepresentativeConfirmed = false;
      this.isOpenModalContestationUpload = true;
    },
    onClickAccepted() {
      this.isOpenModalRepresentativeConfirmed = false;
      this.isOpenModalRegisterRepresentative = true;
    },
    onClickNotAccepted() {
      this.isOpenModalRepresentativeConfirmed = false;
      this.isOpenModalRegisterRepresentative = false;
      this.isOpenModalContestationUpload = true;
    },
    async startContestation() {
      if (!this.modalContestationUploadEnableSentBtn) {
        return;
      }
      const loader = this.$loading.show({ container: this.$refs.formContainer, canCancel: false });
      const {
        stName, stDocument, stEmail, stPhone,
      } = this.userLogged;
      const strAdress = `${this.address.address}, ${this.address.neighborhood}`;
      const paramsTerm: CreateReportTermParams = {
        // @ts-ignore
        nameMain: stName,
        document: stDocument,
        tokenKey: this.userLogged.company.stKey,
        cdTerritory: this.territory.id,
        carNumber: this.territory.car.replaceAll('-', ''),
        territoryName: this.territory.name,
        street: strAdress,
        number: this.address.number,
        complement: this.address.complement,
        city: this.address.city,
        state: this.address.state,
        cep: this.address.zipCode,
        email: stEmail,
        telephone: stPhone,
        // @ts-ignore
        cdAgent: this.territory.agents[0].id,
        representativeName: this.territory?.representative?.name !== undefined ? this.territory.representative.name : 'Não informado',
        representativeDocumentNumber: this.territory?.representative?.document !== undefined ? this.territory.representative.document : '0',
        representativePosition: this.territory?.representative?.office !== undefined ? this.territory.representative.office : 'Não informado',
        isAssing: false,
      };
      try {
        createReportTerm(paramsTerm).then((data) => {
          this.term = { ...data };
        });
        this.getTerritoryByCarCode(this.territory.car);
        const resp = await getTerritoryByIdService(this.territory.id);
        const insertParams: InsertRegisterParams = {
          territoryId: this.territory.id,
          tokenKey: this.userLogged.company.stKey,
          name: this.territory.name,
          status: 'Pendente',
          car: this.territory.car.replaceAll('-', ''),
          document: this.territory.agents[0].document || '',
          city: resp.city,
          nameProducer: this.userLogged.stName,
        };
        const uploadInput = this.$refs.uploadContestation;
        const file = uploadInput.files && uploadInput.files.length > 0 ? uploadInput.files[0] : null;
        const uploadParams: UploadConstestationDocumentParams = {
          tokenKey: this.userLogged.company.stKey,
          cdTerritory: this.territory.id,
          nameTerritory: this.territory.name,
          city: this.territory.city,
          state: this.territory.state,
          file,
        };

        const requests = [
          insertConstestation(insertParams),
          file ? UploadConstestationDocument(uploadParams) : Promise.resolve(),
          updateStatusTerritoryOfficial(this.getStepDate.territory.id, 'PROVISORIO'),
          this.changeStatusTerritoryCarRequest('PROVISORIO'),
        ];
        await Promise.all(requests);
        this.modalContestationOk = true;
      } catch (e) {
        showError('Não foi possível enviar a contestação. Tente novamente mais tarde');
      }
      this.isOpenModalContestation = false;
      this.isOpenModalRepresentativeConfirmed = false;
      this.isOpenModalRegisterRepresentative = false;
      this.isOpenModalContestationUpload = false;
      this.modalContestationUploadEnableSentBtn = false;
      this.modalContestationUploadfileNotAccept = false;
      this.$refs.uploadContestation.files = null;
      this.fileUploadName = [];

      this.getDocumentContastation();
      this.getTerritoryById();
      this.getStatus();

      loader.hide();
    },
    enableDragAndDropUploadContestation() {
      function preventDefaults(e) {
        e.preventDefault();
        e.stopPropagation();
      }

      const container = this.$refs.uploadContestationBox;
      ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {
        container.addEventListener(eventName, preventDefaults, false);
        document.body.addEventListener(eventName, preventDefaults, false);
      });

      container.addEventListener('drop', (event) => {
        event.preventDefault();
        const { files } = event.dataTransfer;
        if (files.length > 0) {
          const input = this.$refs.uploadContestation;
          input.files = files;
          this.updateSelect();
        }
      });
    },
  },
  provide() {
    return {
      getStepDate: computed(() => this.getStepDate),
      userLogged: computed(() => this.userLogged),
    };
  },
  async created() {
    getPixTxId(this.$route.params.id, this.userLoged.company.stKey).then((responseTxid) => {
      this.qrCodePix = responseTxid[0]?.qrCode;
      this.txId = responseTxid[0]?.txId;
      if (responseTxid.length > 0) {
        getPix(this.txId).then((respData) => {
          if (respData.status === 'CONCLUIDA') {
            this.pixElement = true;
            updateTickets(this.$route.params.id);
            this.statusPix = 'Quitado';
          }
          if (respData.status === 'ATIVA') {
            this.pixElement = true;
            this.statusPix = 'Em dia';
          }
        });
      }
    });
    await this.getDocumentContastation();
    await this.getTerritoryById();
    this.enableDragAndDropUploadContestation();
    // await this.appointmentRequest();
    this.verifyPenalty();
    this.getLinkGix();
    this.getReportRequest();
    this.getLinkDocumentTermCommitment();
    const { idUser } = JSON.parse(sessionStorage.getItem('userLogged') || '{}');
    const { company } = JSON.parse(sessionStorage.getItem('userLogged') || '{}');
    const bearer = sessionStorage.getItem('chave') || '{}';
    const stKey = this.userLoged.company.stKey.toString();
    this.gixData = apiGixget(idUser, bearer, stKey);
    this.dataCdTerritory.cdTerritory = this.territory.id;
    this.dataPenalty = await getPenalty(this.territory.id);
    if (this.dataPenalty.length !== 0) {
      this.penaltyPageButton = true;
    }
    this.actData = await getAct(company.stKey, this.territory.id);
    this.getStatus();
    const reduced = [] as any;
    this.actData.objectResult.forEach((item: any) => {
      const duplicated = reduced.findIndex((redItem: any) => {
        return item?.act === redItem?.act;
      }) > -1;
      if (!duplicated) {
        reduced.push(item);
      }
    });
    let count = 0;
    this.actDataResult = reduced;
    this.tickets = await getTickets({ cdTerritory: this.territory.id });
    this.lengthTicket = this.tickets.objectResult.length;
    this.ticketsResult = this.tickets.objectResult;
    this.allPayed = this.ticketsResult.every((boleto) => boleto.status === 'payed');
    this.ticketsTwo = await getTickets({ cdTerritory: this.territory.id });
    this.convertDataTicketsArray();
    const ultimoBoletoPago = this.tickets.objectResult.sort((a, b) => a.dueDate - b.dueDate)
      .reverse()
      .find((boleto) => boleto.status === 'payed');
    // Use o método add() para adicionar 2 meses à data
    if (this.tickets.objectResult.length === 1) {
      this.ticketsResult = this.tickets.objectResult;
      const allPayed = this.ticketsResult.every((boleto) => boleto.status === 'payed');
      if (allPayed) {
        this.actDataResultFilter = this.actDataResult;
      }
    } else if (this.tickets.objectResult.length !== 0) {
      const dataComAcrescimo = moment(ultimoBoletoPago.dueDate).add(2, 'months');

      // Use o método format() para formatar a data como uma string
      const dataFormatada = dataComAcrescimo.format('YYYY-MM-DD');
      if (this.statusPix === '') {
        this.actDataResultFilter = this.actDataResult.filter((evento) => {
          return evento.act < dataFormatada;
        });
      } else {
        this.actDataResultFilter = this.actDataResult;
      }
      this.ticketsResult = this.tickets.objectResult;
      const todosPagos = this.ticketsResult.every((boleto) => boleto.status === 'payed');
      if (todosPagos) {
        this.actDataResultFilter = this.actDataResult;
      }
      for (let i = 0; i < this.tickets.objectResult.length; i += 1) {
        if (this.tickets.objectResult[i].status === 'payed') {
          count += 1;
        }
      }
      if (count < 2 && this.statusPix === '') {
        this.actDataResultFilter.splice(1, 1);
      }
    }
    this.gixData.then((e) => {
      this.objAct = e.data.objectResult;
    });
  },
});
